// 中文路由

import Layout from "@views/layout";

const zhRouter = [
    {
        path: "/",
        name: "DASHBOARD",
        component: Layout,
        redirect: { name: 'DASHBOARD_LIST' },
        children: [
            {
                path: "/en/index/index",
                name: "DASHBOARD_LIST",
                meta: {
                    title: "Home-OceanClub technical community", personname: "DASHBOARD_LIST"
                },
                component: () => import('@views/home/index'),
            }
        ]
    },
    // 活动 active
    {
        path: "/",
        name: "ACTIVE",
        component: Layout,
        redirect: { name: 'ACTIVE_LIST' },
        children: [
            {
                path: "/en/activity/index",
                name: "ACTIVE_LIST",
                meta: { title: "Events-OceanClub technical community", personname: 'ACTIVE_LIST' },
                component: () => import('@views/active/index'),
            }
        ]
    },
    // 赞助
    {
        path: "/",
        name: "STATIONED",
        component: Layout,
        redirect: { name: 'STATIONED_LIST' },
        children: [
            {
                path: "/en/stationed/index",
                name: "STATIONED_LIST",
                meta: { title: "Experts-OceanClub technical community", personname: 'STATIONED_LIST' },
                component: () => import('@views/stationed/index'),
            },
            {
                path: "/en/stationed/info/:id/:tab",
                name: "STATIONED_INFO",
                meta: { title: "Experts-OceanClub technical community", personname: 'STATIONED_LIST' },
                component: () => import('@views/stationed/info'),
            },
            {
                path: "/en/stationed/application",
                name: "STATIONED_APPLICATION",
                meta: { title: "Experts-OceanClub technical community", personname: 'STATIONED_LIST', hideFooter: true },
                component: () => import('@views/stationed/application'),
            },
            {
                path: "/en/stationed/mvp",
                name: "STATIONED_APPLICATION",
                meta: { title: "Experts-OceanClub technical community", personname: 'STATIONED_LIST', hideFooter: true },
                component: () => import('@views/mvp/index'),
            },
        ]
    },
    // 活动详情 active
    {
        path: "/",
        name: "ACTIVEINFO",
        component: Layout,
        redirect: { name: 'ACTIVEINFO_LIST' },
        children: [
            {
                path: "/en/activity/info/:id",
                name: "ACTIVE_LIST",
                meta: { title: "Events-OceanClub technical community", personname: 'ACTIVE_LIST' },
                component: () => import('@views/activeInfo/index'),
            }
        ]
    },
]

export default zhRouter;